const GaUtils = {
  event: (action, params = {}) => {
    window.gtag('event', action, params);
  },
};

export default GaUtils;
